/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureSnapshot {
    getFixupPrototypeFunction() { return TagPostureSnapshot.fixupPrototype; }

    static newInstance(model: Partial<TagPostureSnapshot>): TagPostureSnapshot {
        let obj = Object.assign(new TagPostureSnapshot(), model);
        TagPostureSnapshot.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureSnapshot>): TagPostureSnapshot {
        if (!model) return null;
        return TagPostureSnapshot.newInstance(<TagPostureSnapshot> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureSnapshot) {
        if (!obj) return;

        models.TagPostureSnapshot.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureSnapshot): boolean {
        Object.setPrototypeOf(obj, TagPostureSnapshot.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.progress) {
            models.TagPostureSnapshotProgress.fixupPrototype(this.progress);
        }
    }

    snapshot_id: string;

    /**
     * Id of the account associated with the snapshot
     */
    account_id: string;

    /**
     * When the snapshot was created
     */
    created_at: Date;

    /**
     * When the snapshot was updated
     */
    updated_at: Date;

    /**
     * User ID of user who created the snapshot
     */
    created_by: string;

    /**
     * Status of the snapshot
     */
    status: models.TagPostureSnapshotStatus;

    /**
     * Reason for triggering the snapshot
     */
    reason: models.TagPostureSnapshotReason;

    /**
     * Progress of the generation
     */
    progress: models.TagPostureSnapshotProgress;

}
